(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-group"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (root.dataset.carouselInit === 'true') return;
      root.dataset.carouselInit = 'true';

      var track = root.querySelector('[data-carousel-track]');
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      var dotsWrap = root.querySelector('[data-carousel-dots]');
      if (!track) return;

      var loop = root.dataset.loop === 'true';
      var autoplay = root.dataset.autoplay === 'true';
      var autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;
      var autoplayTimer = null;
      var currentIndex = 0;
      var isDragging = false;
      var dragMoved = false;
      var pointerStartX = 0;
      var scrollStartLeft = 0;

      function getSlides() {
        return Array.prototype.slice.call(track.children);
      }

      function getGap() {
        var style = getComputedStyle(track);
        return parseFloat(style.columnGap || style.gap) || 0;
      }

      function getStep() {
        var slides = getSlides();
        if (!slides.length) return 0;
        return slides[0].getBoundingClientRect().width + getGap();
      }

      function getVisibleCount() {
        var step = getStep();
        if (!step) return 1;
        return Math.max(1, Math.round(track.clientWidth / step));
      }

      function getMaxIndex() {
        var total = getSlides().length;
        var visible = getVisibleCount();
        return Math.max(0, total - visible);
      }

      function clampOrWrap(index) {
        var maxIndex = getMaxIndex();
        if (loop) {
          if (index < 0) return maxIndex;
          if (index > maxIndex) return 0;
          return index;
        }
        return Math.min(Math.max(index, 0), maxIndex);
      }

      function goToIndex(index, smooth) {
        var slides = getSlides();
        if (!slides.length) return;
        currentIndex = clampOrWrap(index);
        var step = getStep();
        track.scrollTo({
          left: currentIndex * step,
          behavior: smooth === false ? 'auto' : 'smooth',
        });
        updateUI();
      }

      function syncIndexFromScroll() {
        var step = getStep();
        if (!step) return;
        currentIndex = Math.min(Math.max(Math.round(track.scrollLeft / step), 0), getMaxIndex());
        updateUI();
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var count = getMaxIndex() + 1;
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel-block__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener(
            'click',
            (function (index) {
              return function () {
                stopAutoplay();
                goToIndex(index);
                if (autoplay) startAutoplay();
              };
            })(i)
          );
          dotsWrap.appendChild(dot);
        }
      }

      function updateUI() {
        if (dotsWrap) {
          var dots = dotsWrap.querySelectorAll('.carousel-block__dot');
          dots.forEach(function (dot, index) {
            dot.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
          });
        }

        if (prevBtn) prevBtn.disabled = !loop && currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = !loop && currentIndex >= getMaxIndex();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stopAutoplay();
          goToIndex(currentIndex - 1);
          if (autoplay) startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stopAutoplay();
          goToIndex(currentIndex + 1);
          if (autoplay) startAutoplay();
        });
      }

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        if (isDragging) return;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(syncIndexFromScroll, 120);
      });

      /* Drag to scroll (mouse + touch via Pointer Events) */
      track.addEventListener('pointerdown', function (e) {
        if (
          e.target.closest('button') ||
          e.target.closest('deferred-media') ||
          e.target.closest('video') ||
          e.target.closest('iframe') ||
          e.target.closest('[data-custom-play-trigger]')
        ) {
          return;
        }

        if (e.button !== undefined && e.button !== 0) return;

        isDragging = true;
        dragMoved = false;
        pointerStartX = e.clientX;
        scrollStartLeft = track.scrollLeft;
        track.classList.add('is-dragging');

        stopAutoplay();

        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var dx = e.clientX - pointerStartX;
        if (Math.abs(dx) > 10) dragMoved = true; // Micro-movement ko skip karne ke liye threshold 10 kiya
        track.scrollLeft = scrollStartLeft - dx;
      });

      function endDrag(e) {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        try {
          track.releasePointerCapture(e.pointerId);
        } catch (err) {}
        syncIndexFromScroll();
        goToIndex(currentIndex);
        if (autoplay) startAutoplay();
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function (e) {
        if (isDragging) endDrag(e);
      });

      /* Prevent link/click firing right after a drag */
      track.addEventListener(
        'click',
        function (e) {
          if (dragMoved) {
            e.preventDefault();
            e.stopPropagation();
            dragMoved = false;
          }
        },
        true
      );

      /* --- UPGRADED VIDEO PLAY / PAUSE LOGIC FOR DEFERRED MEDIA --- */
      var deferredMedias = track.querySelectorAll('deferred-media');

      deferredMedias.forEach(function (mediaContainer) {
        var customPlayBtn = mediaContainer.querySelector('[data-custom-play-trigger]');

        if (customPlayBtn) {
          customPlayBtn.addEventListener('click', function (e) {
            if (dragMoved) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            e.stopPropagation();

            var posterButton = mediaContainer.querySelector(
              '.deferred-media__poster-button:not(.custom-carousel-video-btn)'
            );
            if (posterButton && !mediaContainer.hasAttribute('loaded')) {
              posterButton.click();
              setTimeout(function () {
                toggleMediaState(mediaContainer, customPlayBtn);
              }, 300);
              return;
            }

            toggleMediaState(mediaContainer, customPlayBtn);
          });
        }
      });

      function toggleMediaState(container, btn) {
        var nativeVideo = container.querySelector('video');
        var iframeVideo = container.querySelector('iframe');

        if (nativeVideo) {
          if (nativeVideo.paused) {
            nativeVideo.play();
            btn.style.setProperty('display', 'none', 'important');
          } else {
            nativeVideo.pause();
            btn.style.setProperty('display', 'flex', 'important');
          }

          nativeVideo.onpause = function () {
            btn.style.setProperty('display', 'flex', 'important');
          };
          nativeVideo.onplay = function () {
            btn.style.setProperty('display', 'none', 'important');
          };
          return;
        }

        if (iframeVideo) {
          var src = iframeVideo.src || '';
          var isPlaying = container.dataset.playingState === 'true';

          if (src.includes('youtube.com') || src.includes('youtube-nocookie.com')) {
            if (!isPlaying) {
              iframeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              container.dataset.playingState = 'true';
              btn.style.setProperty('display', 'none', 'important');
            } else {
              iframeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              container.dataset.playingState = 'false';
              btn.style.setProperty('display', 'flex', 'important');
            }
          } else if (src.includes('player.vimeo.com')) {
            if (!isPlaying) {
              iframeVideo.contentWindow.postMessage('{"method":"play"}', '*');
              container.dataset.playingState = 'true';
              btn.style.setProperty('display', 'none', 'important');
            } else {
              iframeVideo.contentWindow.postMessage('{"method":"pause"}', '*');
              container.dataset.playingState = 'false';
              btn.style.setProperty('display', 'flex', 'important');
            }
          }
        }
      }
      /* ------------------------------------------------------------- */

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          goToIndex(currentIndex + 1);
        }, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      if (autoplay) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        startAutoplay();
      }

      buildDots();
      updateUI();

      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          buildDots();
          goToIndex(currentIndex, false);
        }, 150);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (event) {
      var carousel = event.target.closest('[data-carousel]');
      if (!carousel) return;
      var track = carousel.querySelector('[data-carousel-track]');
      var selectedBlock = event.target;
      if (track && track.contains(selectedBlock)) {
        selectedBlock.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-shopping-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initVideoShoppingCarousel(root) {
      if (root.dataset.vsReady === 'true') return;

      var track = root.querySelector('[data-vs-track]');
      if (!track) return;

      var blockId = root.dataset.vsBlockId;
      var modal = root.nextElementSibling;

      if (!modal || modal.getAttribute('data-vs-modal') !== blockId) {
        modal = document.querySelector('[data-vs-modal="' + blockId + '"]');
      }

      if (!modal) {
        console.warn('Video Shopping modal not found:', blockId);
        return;
      }

      document
        .querySelectorAll('body > .vs-shopping-modal[data-vs-modal="' + blockId + '"]')
        .forEach(function (oldModal) {
          if (oldModal !== modal) oldModal.remove();
        });

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      root.dataset.vsReady = 'true';

      /* =========================
       REFERENCES
    ========================= */

      var carouselPrev = root.querySelector('[data-vs-prev]');
      var carouselNext = root.querySelector('[data-vs-next]');
      var dotsWrapper = root.querySelector('[data-vs-dots]');

      var stage = modal.querySelector('[data-vs-stage]');
      var main = modal.querySelector('[data-vs-main]');
      var content = modal.querySelector('[data-vs-modal-content]');
      var incoming = modal.querySelector('[data-vs-incoming]');

      var productArea = modal.querySelector('[data-vs-product-area]');

      var modalPrev = modal.querySelector('[data-vs-modal-prev]');
      var modalNext = modal.querySelector('[data-vs-modal-next]');

      var farPrev = modal.querySelector('[data-vs-preview-far-prev]');
      var nearPrev = modal.querySelector('[data-vs-preview-prev]');
      var nearNext = modal.querySelector('[data-vs-preview-next]');
      var farNext = modal.querySelector('[data-vs-preview-far-next]');

      var muteButton = modal.querySelector('[data-vs-mute]');
      var volumeIcon = modal.querySelector('[data-vs-volume-icon]');
      var mutedIcon = modal.querySelector('[data-vs-muted-icon]');

      var closeButtons = modal.querySelectorAll('[data-vs-close]');

      /* =========================
       STATE
    ========================= */

      var carouselIndex = 0;
      var modalIndex = 0;
      var autoplayTimer = null;

      var dragging = false;
      var dragMoved = false;
      var startX = 0;
      var startScroll = 0;

      var modalSliding = false;
      var modalMuted = false;

      var loop = root.dataset.vsLoop === 'true';
      var autoplay = root.dataset.vsAutoplay === 'true';

      var autoplaySpeed = (parseFloat(root.dataset.vsAutoplaySpeed) || 4) * 1000;

      /* =========================
       SLIDES
    ========================= */

      function getSlides() {
        return Array.prototype.slice.call(track.querySelectorAll('[data-vs-video-item]'));
      }

      /* =========================
       NORMAL CAROUSEL
    ========================= */

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.gap || styles.columnGap) || 0;
      }

      function getStep() {
        var slides = getSlides();

        if (!slides.length) return 0;

        return slides[0].getBoundingClientRect().width + getGap();
      }

      function getVisibleCount() {
        var step = getStep();

        if (!step) return 1;

        return Math.max(1, Math.round(track.clientWidth / step));
      }

      function getMaxIndex() {
        return Math.max(0, getSlides().length - getVisibleCount());
      }

      function normalizeCarouselIndex(index) {
        var max = getMaxIndex();

        if (loop) {
          if (index < 0) return max;
          if (index > max) return 0;
        }

        return Math.min(Math.max(index, 0), max);
      }

      function goToCarouselIndex(index, smooth) {
        carouselIndex = normalizeCarouselIndex(index);

        track.scrollTo({
          left: carouselIndex * getStep(),
          behavior: smooth === false ? 'auto' : 'smooth',
        });

        updateCarouselUI();
      }

      /* =========================
       DOTS
    ========================= */

      function buildDots() {
        if (!dotsWrapper) return;

        dotsWrapper.innerHTML = '';

        var count = getMaxIndex() + 1;

        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'video-shopping-carousel__dot';

          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));

          (function (dotIndex) {
            dot.addEventListener('click', function () {
              stopAutoplay();
              goToCarouselIndex(dotIndex);
              startAutoplay();
            });
          })(i);

          dotsWrapper.appendChild(dot);
        }
      }

      function updateCarouselUI() {
        if (dotsWrapper) {
          var dots = dotsWrapper.querySelectorAll('.video-shopping-carousel__dot');

          dots.forEach(function (dot, index) {
            dot.classList.toggle('is-active', index === carouselIndex);
          });
        }

        if (carouselPrev) {
          carouselPrev.disabled = !loop && carouselIndex <= 0;
        }

        if (carouselNext) {
          carouselNext.disabled = !loop && carouselIndex >= getMaxIndex();
        }
      }

      /* =========================
       NORMAL ARROWS
    ========================= */

      if (carouselPrev) {
        carouselPrev.addEventListener('click', function () {
          stopAutoplay();

          goToCarouselIndex(carouselIndex - 1);

          startAutoplay();
        });
      }

      if (carouselNext) {
        carouselNext.addEventListener('click', function () {
          stopAutoplay();

          goToCarouselIndex(carouselIndex + 1);

          startAutoplay();
        });
      }

      /* =========================
       NORMAL CAROUSEL DRAG
    ========================= */

      track.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) {
          return;
        }

        dragging = true;
        dragMoved = false;

        startX = event.clientX;
        startScroll = track.scrollLeft;

        stopAutoplay();
      });

      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;

        var distance = event.clientX - startX;

        if (Math.abs(distance) > 8) {
          dragMoved = true;

          track.classList.add('is-dragging');
        }

        if (dragMoved) {
          track.scrollLeft = startScroll - distance;
        }
      });

      function finishCarouselDrag() {
        if (!dragging) return;

        dragging = false;

        track.classList.remove('is-dragging');

        if (dragMoved) {
          var step = getStep();

          if (step) {
            carouselIndex = Math.round(track.scrollLeft / step);

            carouselIndex = Math.min(Math.max(carouselIndex, 0), getMaxIndex());

            goToCarouselIndex(carouselIndex);
          }
        }

        startAutoplay();
      }

      track.addEventListener('pointerup', finishCarouselDrag);

      track.addEventListener('pointercancel', finishCarouselDrag);

      track.addEventListener('pointerleave', function () {
        if (dragging) {
          finishCarouselDrag();
        }
      });

      track.addEventListener(
        'click',
        function (event) {
          if (!dragMoved) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          dragMoved = false;
        },
        true
      );

      /* =========================
       POPUP INDEX
    ========================= */

      function normalizeModalIndex(index) {
        var slides = getSlides();

        if (!slides.length) return 0;

        while (index < 0) {
          index += slides.length;
        }

        while (index >= slides.length) {
          index -= slides.length;
        }

        return index;
      }

      /* =========================
       SIDE PREVIEWS
    ========================= */

      function getPreviewSource(slide) {
        if (!slide) return '';

        var image = slide.querySelector('.vs-video-item__image');

        if (image) {
          return image.currentSrc || image.src || '';
        }

        var previewVideo = slide.querySelector('.vs-video-item__preview-video');

        if (previewVideo && previewVideo.poster) {
          return previewVideo.poster;
        }

        var template = slide.querySelector('[data-vs-popup-template]');

        if (template) {
          var templateVideo = template.content.querySelector('video');

          if (templateVideo && templateVideo.poster) {
            return templateVideo.poster;
          }
        }

        return '';
      }

      function renderSidePreview(container, index) {
        if (!container) return;

        var slides = getSlides();

        if (!slides.length) return;

        index = normalizeModalIndex(index);

        container.innerHTML = '';

        var source = getPreviewSource(slides[index]);

        if (!source) return;

        var image = document.createElement('img');

        image.src = source;
        image.alt = '';
        image.loading = 'eager';
        image.draggable = false;

        container.appendChild(image);
      }

      function updateSidePreviews() {
        renderSidePreview(farPrev, modalIndex - 2);

        renderSidePreview(nearPrev, modalIndex - 1);

        renderSidePreview(nearNext, modalIndex + 1);

        renderSidePreview(farNext, modalIndex + 2);
      }

      /* =========================
       PRODUCT
    ========================= */

      function cloneSlideProduct(slide) {
        if (!slide) return null;

        var template = slide.querySelector('[data-vs-product-template]');

        if (!template) return null;

        return template.content.cloneNode(true);
      }

      function renderProduct(index) {
        if (!productArea) return;

        productArea.innerHTML = '';

        var slides = getSlides();

        if (!slides.length) return;

        index = normalizeModalIndex(index);

        var fragment = cloneSlideProduct(slides[index]);

        if (!fragment) return;

        productArea.appendChild(fragment);
      }

      /* =========================
       MUTE UI
    ========================= */

      function updateMuteUI() {
        if (volumeIcon) {
          volumeIcon.hidden = modalMuted;
        }

        if (mutedIcon) {
          mutedIcon.hidden = !modalMuted;
        }

        if (muteButton) {
          muteButton.setAttribute('aria-label', modalMuted ? 'Unmute video' : 'Mute video');
        }
      }

      /* =========================
       MEDIA HELPERS
    ========================= */

      function getNativeVideo(container) {
        if (!container) return null;

        return container.querySelector('video');
      }

      function getIframe(container) {
        if (!container) return null;

        return container.querySelector('iframe');
      }

      function removeNativeControls(container) {
        var video = getNativeVideo(container);

        if (!video) return;

        video.controls = false;
        video.removeAttribute('controls');
      }

      function applyMuteState(container) {
        if (!container) return;

        var video = getNativeVideo(container);

        if (video) {
          video.muted = modalMuted;
          video.defaultMuted = modalMuted;

          if (!modalMuted) {
            video.volume = 1;
          }

          return;
        }

        var iframe = getIframe(container);

        if (!iframe) return;

        var source = iframe.src || '';

        if (source.indexOf('youtube') !== -1) {
          try {
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: modalMuted ? 'mute' : 'unMute',
                args: [],
              }),
              '*'
            );
          } catch (error) {}
        }

        if (source.indexOf('vimeo') !== -1) {
          try {
            iframe.contentWindow.postMessage(
              JSON.stringify({
                method: 'setVolume',
                value: modalMuted ? 0 : 1,
              }),
              '*'
            );
          } catch (error) {}
        }
      }

      function stopMedia(container, reset) {
        if (!container) return;

        var video = getNativeVideo(container);

        if (video) {
          try {
            video.pause();
          } catch (error) {}

          if (reset) {
            try {
              video.currentTime = 0;
            } catch (error) {}
          }
        }

        var iframe = getIframe(container);

        if (!iframe) return;

        var source = iframe.src || '';

        if (source.indexOf('youtube') !== -1) {
          try {
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: [],
              }),
              '*'
            );
          } catch (error) {}
        }

        if (source.indexOf('vimeo') !== -1) {
          try {
            iframe.contentWindow.postMessage(
              JSON.stringify({
                method: 'pause',
              }),
              '*'
            );
          } catch (error) {}
        }
      }

      /* =========================
       PLAY MEDIA

       NATIVE CONTROLS ARE
       ALWAYS DISABLED
    ========================= */

      function playMedia(container) {
        if (!container) return;

        var video = getNativeVideo(container);

        if (video) {
          video.playsInline = true;

          video.muted = modalMuted;

          video.defaultMuted = modalMuted;

          video.volume = 1;

          video.controls = false;

          video.removeAttribute('controls');

          updateMuteUI();

          var promise = video.play();

          if (promise && typeof promise.catch === 'function') {
            promise.catch(function (error) {
              console.warn('Video autoplay blocked:', error);

              /*
                Important:
                controls still stay hidden.
              */

              video.controls = false;

              video.removeAttribute('controls');
            });
          }

          return;
        }

        var iframe = getIframe(container);

        if (!iframe) return;

        var source = iframe.src || '';

        if (source.indexOf('youtube') !== -1) {
          if (source.indexOf('autoplay=1') === -1) {
            source += '&autoplay=1';
          }

          source = source.replace(/&mute=[01]/g, '');

          source += modalMuted ? '&mute=1' : '&mute=0';

          iframe.src = source;

          iframe.addEventListener(
            'load',
            function () {
              applyMuteState(container);

              try {
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'playVideo',
                    args: [],
                  }),
                  '*'
                );
              } catch (error) {}
            },
            {
              once: true,
            }
          );

          updateMuteUI();

          return;
        }

        if (source.indexOf('vimeo') !== -1) {
          if (source.indexOf('autoplay=1') === -1) {
            source += '&autoplay=1';
          }

          source = source.replace(/&muted=[01]/g, '');

          source += modalMuted ? '&muted=1' : '&muted=0';

          iframe.src = source;

          iframe.addEventListener(
            'load',
            function () {
              applyMuteState(container);
            },
            {
              once: true,
            }
          );

          updateMuteUI();
        }
      }

      /* =========================
       VIDEO TEMPLATE
    ========================= */

      function cloneSlideMedia(slide) {
        if (!slide) return null;

        var template = slide.querySelector('[data-vs-popup-template]');

        if (!template) return null;

        return template.content.cloneNode(true);
      }

      /* =========================
       RENDER MAIN VIDEO
    ========================= */

      function renderMainVideo(index, shouldPlay) {
        var slides = getSlides();

        if (!slides.length) return;

        modalIndex = normalizeModalIndex(index);

        stopMedia(content, true);

        content.innerHTML = '';

        var fragment = cloneSlideMedia(slides[modalIndex]);

        if (!fragment) {
          console.warn('Video Shopping popup template missing');

          return;
        }

        content.appendChild(fragment);

        removeNativeControls(content);

        updateSidePreviews();

        renderProduct(modalIndex);

        updateMuteUI();

        if (shouldPlay !== false) {
          playMedia(content);
        }
      }

      /* =========================
       OPEN POPUP
    ========================= */

      function openModal(slide) {
        var slides = getSlides();

        var index = slides.indexOf(slide);

        if (index < 0) return;

        modalIndex = index;

        modalMuted = false;

        updateMuteUI();

        modal.classList.add('is-open');

        modal.setAttribute('aria-hidden', 'false');

        document.body.classList.add('vs-shopping-modal-open');

        stopAutoplay();

        renderMainVideo(modalIndex, true);
      }

      /* =========================
       CLOSE POPUP
    ========================= */

      function closeModal() {
        stopMedia(content, true);
        stopMedia(incoming, true);

        modal.classList.remove('is-open');

        modal.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('vs-shopping-modal-open');

        content.innerHTML = '';
        incoming.innerHTML = '';

        if (productArea) {
          productArea.innerHTML = '';
        }

        startAutoplay();
      }

      /* =========================
       VIDEO CARD CLICK
    ========================= */

      function bindVideoTriggers() {
        getSlides().forEach(function (slide) {
          var trigger = slide.querySelector('[data-vs-open]');

          if (!trigger) return;

          if (trigger.dataset.vsTriggerReady === 'true') {
            return;
          }

          trigger.dataset.vsTriggerReady = 'true';

          trigger.addEventListener('click', function (event) {
            if (dragMoved) {
              dragMoved = false;

              event.preventDefault();

              return;
            }

            event.preventDefault();
            event.stopPropagation();

            openModal(slide);
          });
        });
      }

      function bindHoverVideoPlayback() {
        if (window.matchMedia('(max-width: 749px)').matches) return;

        getSlides().forEach(function (slide) {
          var video = slide.querySelector('.vs-video-item__preview-video');
          if (!video || video.dataset.vsHoverReady === 'true') return;

          if (video.hasAttribute('autoplay')) return;

          video.dataset.vsHoverReady = 'true';

          slide.addEventListener('mouseenter', function () {
            video.muted = true;
            video
              .play()
              .then(function () {
                slide.classList.add('is-hover-playing');
              })
              .catch(function () {});
          });

          slide.addEventListener('mouseleave', function () {
            video.pause();
            // video.currentTime = 0;
            slide.classList.remove('is-hover-playing');
          });
        });
      }

      /* =========================
       MUTE BUTTON
    ========================= */

      if (muteButton) {
        muteButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          modalMuted = !modalMuted;

          applyMuteState(content);
          applyMuteState(incoming);

          updateMuteUI();
        });
      }

      /* =====================================================
       SHOPIFY NATIVE CART ACTIONS
    ===================================================== */

      function waitForShopifyActions() {
        return new Promise(function (resolve, reject) {
          var attempts = 0;

          function check() {
            if (
              window.Shopify &&
              Shopify.actions &&
              typeof Shopify.actions.updateCart === 'function' &&
              typeof Shopify.actions.openCart === 'function'
            ) {
              resolve(Shopify.actions);

              return;
            }

            attempts++;

            if (attempts >= 40) {
              reject(new Error('Shopify cart actions are not available.'));

              return;
            }

            window.setTimeout(check, 50);
          }

          check();
        });
      }

      /* =========================
       SMOOTH POPUP SLIDER
       BUTTON ONLY
    ========================= */

      function changeModalVideo(requestedIndex, direction) {
        if (modalSliding) return;

        var slides = getSlides();

        if (slides.length <= 1) {
          return;
        }

        var targetIndex = normalizeModalIndex(requestedIndex);

        modalSliding = true;

        if (modalPrev) {
          modalPrev.disabled = true;
        }

        if (modalNext) {
          modalNext.disabled = true;
        }

        stopMedia(content, false);

        incoming.innerHTML = '';

        incoming.className = 'vs-shopping-modal__incoming';

        var incomingFragment = cloneSlideMedia(slides[targetIndex]);

        if (!incomingFragment) {
          modalSliding = false;

          if (modalPrev) {
            modalPrev.disabled = false;
          }

          if (modalNext) {
            modalNext.disabled = false;
          }

          return;
        }

        incoming.appendChild(incomingFragment);

        removeNativeControls(incoming);

        if (direction === 'prev') {
          incoming.classList.add('is-from-prev');
        } else {
          incoming.classList.add('is-from-next');
        }

        playMedia(incoming);

        void incoming.offsetWidth;

        if (direction === 'prev') {
          stage.classList.add('is-sliding-prev');
        } else {
          stage.classList.add('is-sliding-next');
        }

        requestAnimationFrame(function () {
          incoming.classList.add('is-active');
        });

        window.setTimeout(function () {
          stage.classList.add('is-resetting');

          modalIndex = targetIndex;

          content.innerHTML = '';

          while (incoming.firstChild) {
            content.appendChild(incoming.firstChild);
          }

          incoming.className = 'vs-shopping-modal__incoming';

          incoming.innerHTML = '';

          stage.classList.remove('is-sliding-next', 'is-sliding-prev');

          updateSidePreviews();

          /*
            Update product according
            to current center video.
          */

          renderProduct(modalIndex);

          applyMuteState(content);

          removeNativeControls(content);

          updateMuteUI();

          void stage.offsetWidth;

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              stage.classList.remove('is-resetting');

              modalSliding = false;

              if (modalPrev) {
                modalPrev.disabled = false;
              }

              if (modalNext) {
                modalNext.disabled = false;
              }
            });
          });
        }, 590);
      }

      /* =========================
       POPUP ARROWS ONLY
    ========================= */

      if (modalPrev) {
        modalPrev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (modalSliding) return;

          changeModalVideo(modalIndex - 1, 'prev');
        });
      }

      if (modalNext) {
        modalNext.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (modalSliding) return;

          changeModalVideo(modalIndex + 1, 'next');
        });
      }

      /*
      NO popup drag.
      NO popup swipe.
      NO side preview click.
    */

      /* =========================
       CLOSE
    ========================= */

      closeButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          closeModal();
        });
      });

      /* =========================
       KEYBOARD
       ESC ONLY
    ========================= */

      document.addEventListener('keydown', function (event) {
        if (!modal.classList.contains('is-open')) {
          return;
        }

        if (event.key === 'Escape') {
          closeModal();
        }
      });

      /* =========================
       AUTOPLAY
    ========================= */

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);

          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        if (!autoplay) return;

        if (modal.classList.contains('is-open')) {
          return;
        }

        stopAutoplay();

        autoplayTimer = setInterval(function () {
          goToCarouselIndex(carouselIndex + 1);
        }, autoplaySpeed);
      }

      root.addEventListener('mouseenter', stopAutoplay);

      root.addEventListener('mouseleave', startAutoplay);

      /* =========================
       RESIZE
    ========================= */

      var resizeTimer;

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
          buildDots();

          goToCarouselIndex(carouselIndex, false);

          /*
                Make sure native controls
                never reappear after resize.
              */

          removeNativeControls(content);

          removeNativeControls(incoming);
        }, 150);
      });

      /* =========================
       INITIALIZE
    ========================= */

      bindVideoTriggers();
      bindHoverVideoPlayback();
      buildDots();
      updateCarouselUI();
      updateMuteUI();
      startAutoplay();
    }

    /* =========================
     INIT ALL
  ========================= */

    function initAllVideoShoppingCarousels() {
      document.querySelectorAll('[data-video-shopping-carousel]').forEach(initVideoShoppingCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllVideoShoppingCarousels);
    } else {
      initAllVideoShoppingCarousels();
    }

    document.addEventListener('shopify:section:load', function () {
      initAllVideoShoppingCarousels();
    });

    document.addEventListener('shopify:block:select', function () {
      initAllVideoShoppingCarousels();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
